import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import EducationPage from "./pages/EducationPage";
import HealthcarePage from "./pages/HealthcarePage";
import RealEstatePage from "./pages/RealEstatePage";
import FinancialPage from "./pages/FinancialPage";
import RetailPage from "./pages/RetailPage";
import HospitalityPage from "./pages/HospitalityPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/education" element={<EducationPage />} />
          <Route path="/healthcare" element={<HealthcarePage />} />
          <Route path="/real-estate" element={<RealEstatePage />} />
          <Route path="/financial-services" element={<FinancialPage />} />
          <Route path="/retail" element={<RetailPage />} />
          <Route path="/hospitality" element={<HospitalityPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
